export default __webpack_public_path__ + "static/media/te-logo.6eb5a230.svg";